import { z } from 'zod';
import { PRODUCT_TYPE_SCHEMA } from './product-types.ts';
import { SUPPORTED_UNITS_SCHEMA } from '../quote-unit/unit-types.ts';

export const NestedProductTypeResponseSchema = z.object({
    name: PRODUCT_TYPE_SCHEMA,
    supportedUnits: z.array(
        z.object({
            unitName: SUPPORTED_UNITS_SCHEMA,
        })
    ),
});
